<template>
    <div>
        <div style="height: 10px; background-color: #f2f2f2"></div>
        <div class="contain">
            <img v-if="data.msmtPicture !== '' " class="newsIcon" :src="imgUrl2 + data.msmtPicture" alt="">
            <div class="title">
                {{data.msmtTitle}}
            </div>
            <p class="time">{{data.adddate}}</p>
            <p class="content">
              {{data.msmtInfo}}
            </p>
            <!-- <div class="signature">
                <div>安庆市教育体育局</div>
                <div>2022年7月6日</div>
            </div> -->
            <div class="enclosure" @click="download">
                <span>附件: </span>
                <img src="../assets/word-1.png" alt="" />
                <span>文件下载.docx</span>
            </div>
            <div class="choice">
                <div class="choice1" @click="goNews">
                    <img src="../assets/历史消息.png" alt="" />
                    <div>历史消息</div>
                </div>
                <div class="choice1" @click="goUser">
                    <img src="../assets/用户中心.png" alt="" />
                    <div>用户中心</div>
                </div>
                <div class="choice1" @click="code">
                    <img src="../assets/订单.png" alt="" />
                    <div>扫码用餐</div>
                </div>
                <div class="choice1" @click="goHome">
                    <img src="../assets/首页.png" alt="" />
                    <div>首页</div>
                </div>
            </div>
        </div>

        <van-popup v-model="showTrue" round closeable>
            <div class="trueCont">
                <div class="tTil">确认支付</div>
                <div class="tCenter">
                    <span class="price">{{ scanAllText.mealFee }}</span>
                    元就餐费
                </div>
                <div class="tUser">
                    <span class="tname" v-if="scanAllText && scanAllText.workerName">{{
                    scanAllText.workerName
                    }}</span>在<span class="tdate" v-if="nowDate">{{ nowDate }}</span>
                </div>
                <div class="tBom">
                    即将支付<span class="taddress" v-if="scanAllText && scanAllText.canteenName">{{ scanAllText.canteenName
                    }}</span>
                </div>
                <van-cell v-if="scanAllText && scanAllText.businessUnitList.length > 1" value-class="van-ellipsis"
                    title="出差单位：" is-link :value="companyText" @click="showCompanuBox" />
                <div class="tBomBtnBox">
                    <div class="tBtnLeft" @click="showTrue = false">撤回</div>
                    <div class="tBtnRight" @click="getScanText2">确定</div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import qs from "qs";
import Vue from "vue";
import { Dialog } from "vant";
Vue.use(Dialog);

export default {
    data() {
        return {
            showFalse: false,
            falseCont: '',
            showTrue: false,
            scanAllText: '',
            nowDate: '',
            scanText: '',
            showCompanu: false,
            companycolumns: [],
            companyId: 0,
            companyText: '请选择',
            timers: false,
            data: {}
        };
    },
    created() {
        let param = {
            // WorkerID: '453246',
            WorkerID: JSON.parse(sessionStorage.getItem("userData")).workerID,
            MID: this.$route.query.mid,
        };
        this.$post('api/Notification/GetNotificationInfo', qs.stringify(param),{
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(res =>{
            console.log(res);
            this.data = res.data

        })
        this.nowDate = this.getnow()
    },
    activated(){
        this.nowDate = this.getnow()
    },
    methods: {
        //下载
        download() {
            let url = 'https://lg.sjw.qz.gov.cn:6081/'
            let a = document.createElement('a')
            a.style.display = 'none'
            a.href = url + this.data.msmtUploadAttachment
            a.download = '文件'//文件名
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
        },
        goNews() {
            this.$router.push({ path: "/news" });
        },
        goUser() {
            this.$router.push({ path: "/mine" });
        },
        code() {
            let _this = this;
            this.$post("api/Dingding/GetJSAPOTicket")
                .then((res) => {
                    if (res.code == 1000) {
                        let ticket = res.data.content.data.accessToken;
                        //01 获取鉴权码
                        // 02  鉴权
                        dd.authConfig({
                            ticket: ticket,
                            jsApiList: ["scan"],
                        })
                            .then((res) => {
                                // 03 判断鉴权结果后，使用获取地理位置
                                dd.scan({
                                    type: "qr",
                                }).then((res) => {
                                    this.getScanText(this.getUrlKey1("qrcode", res.text));
                                });
                            })
                            .catch((err) => {
                                Dialog.alert({
                                    title: "提示",
                                    message: "打开扫码失败",
                                }).then(() => {
                                    // on close
                                });
                            });
                    }
                })
                .catch((err) => {
                    Dialog.alert({
                        title: "提示",
                        message: "打开扫码失败",
                    }).then(() => {
                        // on close
                    });
                });
        },
        goHome() {
            this.$router.push({ path: "/" });
        },
        getScanText(text) {
            this.scanText = text;
            let param = {
                QRCode: text,
                WorkerID: JSON.parse(sessionStorage.getItem("userData")).workerID,
                // WorkerID:102061,
                Probe: false,
            };
            this.$post("api/Canteen/Estimate", qs.stringify(param), {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            }).then((res) => {
                if (res.code == 1000) {
                    this.scanAllText = res.data;
                    if (res.data.businessUnitList.length == 1) {
                        this.companyId = res.data.businessUnitList[0].id;
                    }
                    this.showTrue = true;
                } else {
                    this.falseCont = res.msg || res.message;
                    this.showFalse = true;
                }
            });
        },
        getUrlKey1: function (name, url) {
            return (
                decodeURIComponent(
                    (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
                        url
                    ) || [, ""])[1].replace(/\+/g, "%20")
                ) || null
            );
        },
        getScanText2() {
            if (this.timers) {
                setTimeout(() => {
                    this.timers = false;
                }, 1000);
                return;
            }
            this.timers = true;
            if (this.scanAllText && this.scanAllText.businessUnitList.length > 1) {
                if (!this.companyId) {
                    Toast({
                        message: "请先选择出差单位",
                        position: "bottom",
                    });
                    return;
                }
            }
            this.showTrue = false;
            let param = {
                QRCode: this.scanText,
                WorkerID: JSON.parse(sessionStorage.getItem("userData")).workerID,
                // WorkerID:102061,
                Probe: true,
                Longitude: sessionStorage.getItem("userLon"),
                Latitude: sessionStorage.getItem("userLat"),
                BusinessUnit: this.companyId || 0,
            };
            this.$post("api/Canteen/Estimate", qs.stringify(param), {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            }).then((res) => {
                if (res.code == 1000) {
                    this.$router.push({
                        path: "/scanSucess",
                        query: {
                            oid: res.data.orderID,
                            cid: res.data.canteenID,
                            mealFee: res.data.mealFee,
                        },
                    });
                } else {
                    this.falseCont = res.msg || res.message;
                    this.showFalse = true;
                }
            });
        },
        getnow(dates) {
            var mynow = dates ? new Date(dates) : new Date();//默认的获取的是当前时间
            //通过调用日期对象的方法来重新获取当前的日期时间
            //mynow.setFullYear(2016);
            var year = mynow.getFullYear();//获取年
            var month = (mynow.getMonth() + 1) < 10 ? '0' + (mynow.getMonth() + 1) : (mynow.getMonth() + 1);//获取月
            var day = mynow.getDate() < 10 ? '0' + mynow.getDate() : mynow.getDate();//获取日
            var hour = mynow.getHours() < 10 ? '0' + mynow.getHours() : mynow.getHours();//获取小时
            var minute = mynow.getMinutes() < 10 ? '0' + mynow.getMinutes() : mynow.getMinutes();//获取分钟
            // var second =mynow.getSeconds();//获取秒
            var strdate = year + '-' + month + "-" + day + ' ' + hour + ':' + minute
            return strdate
        }
    },
};
</script>

<style scoped>
.newsIcon {
    width: 100%;
    margin-bottom: 20px;
    border-radius: 10px;
}
.contain {
    padding: 20px 12px;
}

.title {
    font-weight: 700;
}

.time {
    font-size: 11px;
    color: #999;
}

.content {
    font-size: 12px;
    color: #999;
}

.signature {
    text-align: right;
    font-size: 12px;
}

.enclosure {
    /* width: 351px; */
    height: 44px;
    line-height: 44px;
    border-radius: 5px;
    margin: 28px 0 15px;
    padding: 0 15px;
    box-sizing: border-box;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
    margin-top: 100px;
}


.choice {
    /* width: 351px; */
    height: 78px;
    border-radius: 5px;
    padding: 0 15px;
    box-sizing: border-box;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.choice1 {
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/page/messagePage.vue